import { Button, Typography } from '@mui/material';
import React from 'react';
import { DeleteExpenseAttributes } from '../../../../interfaces';
import { Expense } from '../../../../models';
import { Modal } from '../../../../shared/components';

interface Props {
  expense: Expense;
  isOpen: boolean;
  onClose: () => void;
  deleteExpense: (deleteExpenseAttributes: DeleteExpenseAttributes) => void;
}

export default function DeleteExpenseModal(
  {
    expense, isOpen, onClose, deleteExpense,
  }: Props,
) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width={400}
    >
      <>
        <div className="flex flex-col justify-center mb-10">
          <Typography variant="body1" align="center">Você deseja continuar com a deleção?</Typography>
          <Typography variant="body1" align="center">
            Essa ação é
            {' '}
            <b>irreversível</b>
            .
          </Typography>
        </div>

        <div className="w-full flex justify-center">
          <div className="w-6/12 flex flex-row justify-between">
            <Button
              color="secondary"
              variant="contained"
              onClick={() => onClose()}
            >
              Não
            </Button>

            <Button color="error" onClick={() => deleteExpense(expense)}>
              Sim
            </Button>
          </div>
        </div>
      </>
    </Modal>
  );
}
